module.exports = __webpack_public_path__ + "media/images/flags/BN-3fd57da281489c8296634b9c27abdc2f.svg";